import type { ProductShowcaseMode } from "@/store/use-ui-preferences-store";

export type ShowcaseMode = ProductShowcaseMode;

export interface ShowcaseMetrics {
  /** Bir kartın genişliği (px) */
  cardWidth: number;
  /** Kartlar arası boşluk (px) */
  gap: number;
  /** Şeritte aynı anda tam görünen kart sayısı */
  perView: number;
  /** Izgarada bir kolonun en küçük genişliği (px) */
  gridMin: number;
}

const CARD_MIN = 140;
const CARD_MAX = 300;
/** Şeritte sonraki kartın görünen dilimi: "devamı var" ipucu */
const PEEK = 22;

const clamp = (n: number, min: number, max: number) =>
  Math.min(max, Math.max(min, n));

/** Kap genişliğine göre şeritte kaç tam kart sığar */
function stripPerView(width: number): number {
  if (width < 470) return 2;
  if (width < 740) return 3;
  if (width < 1010) return 4;
  return 5;
}

/**
 * Kart ölçüleri kaptan türetilir; pencereden değil. Aynı bileşen 380px'lik
 * dock'ta da 1100px'lik tam sayfa sohbette de kendi genişliğine göre dizilir.
 */
export function getShowcaseMetrics(
  width: number,
  mode: ShowcaseMode,
  itemCount: number,
): ShowcaseMetrics {
  const gap = width < 640 ? 12 : 16;
  const gridMin = width < 640 ? 150 : 170;

  if (mode === "focus") {
    return {
      cardWidth: clamp(Math.round(width * 0.62), 200, 320),
      gap,
      perView: 1,
      gridMin,
    };
  }

  const perView = stripPerView(width);
  // Taşma varsa sonraki kartın bir dilimi görünsün; yoksa kartlar kabı doldursun
  const overflows = itemCount > perView;
  const usable = overflows
    ? width - perView * gap - PEEK
    : width - (perView - 1) * gap;
  const cardWidth = clamp(Math.floor(usable / perView), CARD_MIN, CARD_MAX);

  return { cardWidth, gap, perView, gridMin };
}
